import * as types from '../constants/teamdetails'

const initialState = {
  Status: null,
  apiGetResult: null,
  apiPostResult: null,
  teamdetails: null,
  teamdetailsList: null,
  teamuserList: null,
  switchteamdetailsList: null
}

export function teamDetails(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_TEAM_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_TEAM_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        teamdetails: action.data
      };
    case types.FETCH_TEAM_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false,
        // teamdetailsList:action.error
      };
    case types.FETCH_TEAM_RESET:
      return {
        ...state,
        Status: null,
        apiGetResult: null,
        teamdetailsList: null,
        teamdetails: null,
      };
    case types.FETCH_TEAM_LIST_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_TEAM_LIST_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        teamdetailsList: action.data
      };
    case types.FETCH_TEAM_LIST_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false,
        // teamdetailsList:action.error
      };
    case types.FETCH_SWITCH_TEAM_LIST_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_SWITCH_TEAM_LIST_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        switchteamdetailsList: action.data
      };
    case types.FETCH_SWITCH_TEAM_LIST_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false
      };
      case types.FETCH_SWITCH_TEAM_LIST_REQUEST_RESET:
        return {
          ...state,
          Status: false,
          apiGetResult: false,
          switchteamdetailsList: action.data
        };
    case types.FETCH_TEAM_USER_LIST_REQUEST:
      return {
        ...state,
        Status: true
      };
    case types.FETCH_TEAM_USER_LIST_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        teamuserList: action.data
      };
    case types.FETCH_TEAM_USER_LIST_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false,
      };
    case types.ADD_TEAM_RESET:
      return {
        ...initialState,
        Status: null,
        apiPostResult: null
      };
    case types.ADD_TEAM_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.ADD_TEAM_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true
      };
    case types.ADD_TEAM_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false
      };
    default:
      return state;
  }
} 


// WEBPACK FOOTER //
// ./reducers/teamdetails.js